


































import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import { BusEvent, BusEventTargets } from '@/containers/globals/BusEvent';

@Component
export default class FormDialog extends Vue {
  @Prop()
  private bootEventType!: BusEventTargets;

  private formdialog: boolean = false;
  private valid: boolean = true;

  public created(): void {
    BusEvent.$on(this.bootEventType, (value: boolean) => {
      this.formdialog = value;
    });
  }

  private clickSave(): void {
    if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
      this.saveContent();
    }
  }

  @Emit('form-dialog-save')
  private saveContent(): void {
    this.formdialog = false;
  }

  @Emit('form-dialog-cancel')
  private clickCancel(): void {
    this.formdialog = false;
  }
}
